<div class="container py-6 flex-fill d-flex flex-column" style="height: calc(100vh - 112px);">
    <div>
        <div class="d-flex">
            <div style="width: 240px;">
                <div class="ml-1 font-size-12 color-no2Pencil" cvLocalizedText langSection="Integration_Logs" langKey="Last_Attempt">Last Attempt Date</div>
                <cv-baremetrics-calendar *ngIf="presetsLoaded"
                                         class="d-block daterange daterange--double mb-3"
                                         [(startDate)]="selectedFilters.StartDate"
                                         [(endDate)]="selectedFilters.EndDate"
                                         [presets]="dateRangePresets"
                                         [earliestDate]="earliestDate"></cv-baremetrics-calendar>
            </div>
            <div style="width: 240px;" class="ml-6">
                <div class="ml-1 font-size-12 color-no2Pencil" cvLocalizedText langSection="Integration_Logs" langKey="Result">Result</div>
                <mat-form-field class="cv-material-control" appearance="fill">
                    <mat-select class="my-auto lato-regular" panelClass="cv-material-control overflow-hidden" [multiple]="true" [value]="selectedFilters.Result">
                        <mat-option *ngFor="let result of resultOptions; index as i" [value]="i" (onSelectionChange)="onMatSelectChange($event)">{{result}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="d-flex justify-content-between">
            <button cvLocalizedText langSection="Common" langKey="Apply"
                    type="button" 
                    class="btn btn-primary" 
                    style="align-self: center;" 
                    (click)="loadLogs()" 
                    [disabled]="isLoading">Apply</button>
            <div class="my-2 search-box live-search" style="width:240px;">
                <input type="search"
                       class="form-control form-control-gray"
                       autocomplete="off"
                       placeholder="Search..."
                       (input)="onTextChanged()"
                       [(ngModel)]="filterText"
                       cvLocalizedPlaceholder langSection="Common" langKey="Search" />
                <span class="clear-input" [hidden]="!filterText" (click)="clearFilter()"></span>
            </div>
        </div>
    </div>
    <ag-grid-angular *ngIf="gridOptions && filtersApplied" class="ag-theme-balham ag-basic h-100 mt-3" [gridOptions]="gridOptions"></ag-grid-angular>
</div>
